module.exports = __webpack_public_path__ + "img/gift-content-ar.3523f26c.png";